function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { genComponentStyleHook } from "../../_util/genComponentStyleHook";
var genTypeStyle = function genTypeStyle(color, token) {
  // 左侧颜色条宽度设置为 8px，但还需要绕 Y 轴旋转 60deg，因此最后的投影宽度实际为 4px
  var borderWidth = 8;
  return {
    content: '""',
    width: borderWidth,
    // 绕 Y 轴旋转 60deg 是为了让圆角有一定的视觉拉伸，以与原先的边框贴合更加紧密
    transform: 'rotateY(60deg)',
    backgroundColor: color,
    position: 'absolute',
    height: "calc(100% - ".concat(token.lineWidth, "px)"),
    left: -token.lineWidth - borderWidth / 2 / 2,
    top: token.lineWidth / 2,
    borderTopLeftRadius: token.borderRadiusLG,
    borderBottomLeftRadius: token.borderRadiusLG
  };
};
var genColoredStyle = function genColoredStyle(color, colorHover, token) {
  var componentCls = token.componentCls,
    iconCls = token.iconCls;
  return _defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls, "-message"), {
    color: color
  }), "".concat(componentCls, "-description"), {
    color: color
  }), "".concat(componentCls, "-close-icon"), _defineProperty(_defineProperty({}, "".concat(iconCls), {
    color: color,
    '&:hover': {
      color: colorHover
    }
  }), "".concat(componentCls, "-close-text"), {
    color: color,
    '&:hover': {
      color: colorHover
    }
  }));
};
export var genAlertStyle = function genAlertStyle(token) {
  var componentCls = token.componentCls,
    colorSuccess = token.colorSuccess,
    colorSuccessHover = token.colorSuccessHover,
    colorInfo = token.colorInfo,
    colorInfoHover = token.colorInfoHover,
    colorWarning = token.colorWarning,
    colorWarningHover = token.colorWarningHover,
    colorError = token.colorError,
    colorErrorHover = token.colorErrorHover,
    colorIcon = token.colorIcon,
    colorIconHover = token.colorIconHover,
    motionDurationMid = token.motionDurationMid;
  // height = fontSize * lineHeight
  var height = token.fontSize * token.lineHeight;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls), _defineProperty(_defineProperty({
    // vertical align to flex-start
    alignItems: 'flex-start !important',
    paddingRight: token.padding
  }, "".concat(componentCls, "-icon"), {
    height: height
  }), "".concat(componentCls, "-close-icon"), {
    height: height,
    color: colorIcon,
    transition: "color ".concat(motionDurationMid),
    '&:hover': {
      color: colorIconHover
    }
  })), "".concat(componentCls, ":not(").concat(componentCls, "-with-description)"), {
    paddingLeft: token.padding
  }), "".concat(componentCls).concat(componentCls, "-with-description"), _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    paddingBlock: token.padding
  }, "".concat(componentCls, "-message"), {
    fontWeight: 500,
    marginBottom: token.marginXXS
  }), "".concat(componentCls, "-description"), {
    color: token.colorTextSecondary
  }), "".concat(componentCls, "-icon"), {
    fontSize: token.fontSizeHeading4,
    height: token.fontSizeHeading3,
    marginInlineEnd: token.margin
  }), "".concat(componentCls, "-action"), {
    marginInlineStart: token.marginXS
  })), "".concat(componentCls, ":not(").concat(componentCls, "-banner):not(").concat(componentCls, "-ghost)"), _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "&".concat(componentCls, "-success::before"), genTypeStyle(colorSuccess, token)), "&".concat(componentCls, "-info::before"), genTypeStyle(colorInfo, token)), "&".concat(componentCls, "-warning::before"), genTypeStyle(colorWarning, token)), "&".concat(componentCls, "-error::before"), genTypeStyle(colorError, token))), "".concat(componentCls).concat(componentCls, "-ghost"), {
    backgroundColor: 'transparent',
    border: 'none',
    padding: 0,
    borderRadius: 0
  }), "".concat(componentCls, "-colored"), _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "&".concat(componentCls, "-success"), genColoredStyle(colorSuccess, colorSuccessHover, token)), "&".concat(componentCls, "-info"), genColoredStyle(colorInfo, colorInfoHover, token)), "&".concat(componentCls, "-warning"), genColoredStyle(colorWarning, colorWarningHover, token)), "&".concat(componentCls, "-error"), genColoredStyle(colorError, colorErrorHover, token)));
};
export default (function (prefixCls) {
  var useStyle = genComponentStyleHook('Alert', function (token) {
    return [genAlertStyle(token)];
  });
  return useStyle(prefixCls);
});